/**
 * Hand this tab to another address, replacing the current entry so Back skips the hand-off screen. Its own module so a
 * test can see the hand-off without navigating jsdom (whose `location` cannot be spied on).
 */
export function handTabTo(url: string): void {
  // programmatic-nav: a true redirect — the View document screen hands the tab to the file's short-lived link.
  window.location.replace(url);
}
